module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-008.2f4f2206.webp";